import { dayjs } from 'element-plus';
import RemoteCenter from './RemoteCenter';

class TimeService {
    static _inst;
    static getInstance() {
        if (!TimeService._inst) TimeService._inst = new TimeService();
        return TimeService._inst;
    }
    static startSync() {
        TimeService.getInstance().startSync();
    }
    static getServerTime() {
        return TimeService.getInstance().getServerTime();
    }
    static getServerTimeStamp() {
        return TimeService.getInstance().getServerTimeStamp();
    }
    static getServerTimeStr() {
        return TimeService.getInstance().getServerTimeStr();
    }
    static countDown(flag, seconds, proc) {
        return TimeService.getInstance().countDown(flag, seconds, proc);
    }
    static countDownTo(flag, time, proc) {
        return TimeService.getInstance().countDownTo(flag, time, proc);
    }
    static countUp(flag, current, proc, timesProc) {
        return TimeService.getInstance().countUp(flag, current, proc, timesProc);
    }
    static clearCountup(flag) {
        return TimeService.getInstance().clearCountup(flag);
    }
    static clearCountDown(flag) {
        return TimeService.getInstance().clearCountDown(flag);
    }

    _countDownMap = {};
    _countUpMap = {};

    _timer = null;
    _checkCount = 0;
    _localCheckTime = -1;
    _lastCheckTime = -1;
    _maxSyncCount = 60 * 30;
    _checkInterval = 10000;
    _timeDiff = null;
    async syncTime() {
        const now = Date.now();
        let time = await RemoteCenter.getServerTime();
        this._localCheckTime = now;
        this._lastCheckTime = now;
        time -= Math.round((Date.now() - now) * 0.5);
        // console.log(time);
        this._timeDiff = time - now;
        // console.log(this._timeDiff);
    }
    async check() {
        const now = Date.now();
        // console.log(new Date(now));
        if (this._checkCount == this._maxSyncCount) {
            await this.syncTime();
            this._checkCount = 0;
            window.clearInterval(this._timer);
            this._timer = window.setInterval(()=> this.check(), this._checkInterval);
        } else {
            const ldiff = Math.abs((this._lastCheckTime + this._checkInterval - now));
            if (ldiff > this._checkInterval) {
                this._timeDiff += this._lastCheckTime + this._checkInterval - now;
                console.log(this._timeDiff);
                await this.syncTime();
                this._checkCount = 0;
                window.clearInterval(this._timer);
                this._timer = window.setInterval(()=> this.check(), this._checkInterval);
            }
            const c = this._checkCount + 1;
            const diff = Math.abs((this._localCheckTime + c * this._checkInterval - now) / c / this._checkInterval);
            if (diff > 0.6) {
                this._timeDiff += this._localCheckTime + c * this._checkInterval - now;
                console.log(this._timeDiff);
                await this.syncTime();
                this._checkCount = 0;
                window.clearInterval(this._timer);
                this._timer = window.setInterval(()=> this.check(), this._checkInterval);
            }
        }
        this._lastCheckTime += this._checkInterval;
        this._checkCount++;
    }
    startSync() {
        this._checkCount = 0;
        this._localCheckTime = -1;
        this.syncTime();
        this._timer = window.setInterval(()=> this.check(), this._checkInterval);
    }
    getServerTime() {
        return new Date(this.getServerTimeStamp());
    }
    getServerTimeStr() {
        return dayjs(this.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss')
    }
    getServerTimeStamp() {
        return Date.now() + this._timeDiff;
    }
    countTimeString(leftTime) {
        const s = Math.round(leftTime / 1000);
        const seconds = s % 60;
        const minutes = Math.floor((s % (60 * 60)) / 60);
        const hours = Math.floor((s % (60 * 60 * 24)) / (60 * 60));
        const days = Math.floor(s / (60 * 60 * 24));
        const secondsStr = (seconds < 10 ? '0' : '') + seconds;
        const minutesStr = (minutes < 10 ? '0' : '') + minutes;
        const hoursStr = (hours < 10 ? '0' : '') + hours;
        const daysStr = days + '';
        return {days, hours, minutes, seconds, daysStr, hoursStr, minutesStr, secondsStr};
    }
    countDown(flag, seconds, proc) {
        const countDown = this._countDownMap[flag];
        if (countDown) window.clearInterval(countDown.timer);
        ((endTime, flag, proc)=> {
            this._countDownMap[flag] = {timer:window.setInterval(()=> {
                const serverTimeStamp = this.getServerTimeStamp();
                const leftTime = endTime - serverTimeStamp;
                if (leftTime > 0) {
                    proc(leftTime, new Date(serverTimeStamp), this.countTimeString(leftTime));
                } else {
                    proc(0, new Date(serverTimeStamp), this.countTimeString(0));
                    const countDown = this._countDownMap[flag];
                    window.clearInterval(countDown.timer)
                }
            }, 1000), time:endTime}
        })(this.getServerTimeStamp() + seconds * 1000, flag, proc);
    }
    countUp(flag, current, proc, timesProc) {
        const countUp = this._countUpMap[flag];
        if (countUp) window.clearInterval(countUp.timer);
        let times = timesProc?.times;
        ((startTime, flag, proc, timesProc)=> {
            this._countUpMap[flag] = {timer:window.setInterval(()=> {
                const serverTimeStamp = this.getServerTimeStamp();
                const passedTime = serverTimeStamp - startTime;
                proc(passedTime, new Date(serverTimeStamp), this.countTimeString(passedTime));
                if (times != null) {
                    times--;
                    if (times == 0) {
                        times = timesProc?.times;
                        timesProc.proc(passedTime);
                    }
                }
            }, 1000), time:startTime}
        })(this.getServerTimeStamp() - current, flag, proc, timesProc);
    }
    clearCountup(flag) {
        const countUp = this._countUpMap[flag];
        if (countUp) window.clearInterval(countUp.timer);
    }
    countDownTo(flag, time, proc) {
        const t = new Date(time);
        const countDown = this._countDownMap[flag];
        if (countDown) window.clearInterval(countDown.timer);
        ((endTime, flag)=> {
            this._countDownMap[flag] = {timer:window.setInterval(()=> {
                const serverTimeStamp = this.getServerTimeStamp();
                const leftTime = endTime - serverTimeStamp;
                if (leftTime > 0) {
                    proc(leftTime, new Date(serverTimeStamp), this.countTimeString(leftTime));
                } else {
                    proc(0, new Date(serverTimeStamp), this.countTimeString(0));
                    const countDown = this._countDownMap[flag];
                    window.clearInterval(countDown.timer)
                }
            }, 1000), time:endTime}
        })(t.getTime(), flag);
    }
    clearCountDown(flag) {
        const countDown = this._countDownMap[flag];
        if (countDown) window.clearInterval(countDown.timer);
    }
}

export default TimeService;